import React from "react";
import Nav from "./Nav";

export default function Order() {
    return (
        <div className="page-content">
            <Nav />
            <main className="order-page">
                <h1>Order</h1>
                <section className="order-row">
                    <div className="order-image">
                        <img src={require('../images/sourdough-coutry-loaves.JPG')} alt="Sourdough country loaf" width="200px" />
                    </div>
                    <div className="order-text">
                        <h2>Current Pickups</h2>
                        <p>Each week, I typically offer a variety of sourdough loaves and other baked goods for pickup. Weekly orders usually open on Thursdays, with pick ups the following Wednesday. All orders are processed through my Hotplate storefront.</p>
                        <a href="https://hotplate.com/onethingkneaded" target="_blank" rel="noreferrer"><button className="primary-button">See this week's pickups</button></a>
                    </div>
                </section>
                <section className="order-row">
                    <div className="order-image">
                        <img src={require('../images/chocolate-croissants.jpg')} alt="Chocolate croissants" width="200px" />
                    </div>
                    <div className="order-text">
                        <h2>Bulk Custom Order</h2>
                        <p>If you have a large celebration or event, you can request a custom bulk order. I ask that you give me a couple weeks notice if possible!</p>
                        {/* <button className="primary-button"><a href="menu">View Menu</a></button> */}
                        <p>Use my <a href='about'>general contact form</a> for all bulk order inquiries.</p>
                    </div>
                </section>
            </main>
        </div>
    )
}